import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../base/api-base.service";
import { SharedFileContractService } from "../interfaces/shared-file-contract.service";
import { NetworkStatusService } from "../network-status.service";
import { SharedFileOfflineService } from "../offline/shared-file-offline.service";
import { SharedFileOnlineService } from "../online/shared-file-online.service";
import { InspectionStructureFormat } from "../../_utils/inspection-structure.utils";

@Injectable({
  providedIn: "root"
})
export class SharedFileService extends ApiService<SharedFileContractService> implements SharedFileContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: SharedFileOfflineService,
    protected onlineService: SharedFileOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  // TR01 PUT /api/v1/shared/file
  sharedFileSasKey(
    dataId: string,
    dataType: string,
    startDate: string,
    exipiryDate: string,
    sharedUserEmailAddress: string[],
    structureFormat?: InspectionStructureFormat
  ): Observable<string> {
    return this.service.sharedFileSasKey(dataId, dataType, startDate, exipiryDate, sharedUserEmailAddress, structureFormat);
  }
}
